import styled from 'styled-components';

import type { ThemeTypes } from '../../../../../types/Theme.namespace';

const ForwardArrowContainer = styled.div<{ color: ThemeTypes.Colors }>`
  color: ${({ theme, color }) => theme.donedeal.colors[color]};
  margin: 0 6px;
  display: flex;
  align-items: center;
`;

export { ForwardArrowContainer };
